/**
 * Extracted validation logic for ticket submission.
 * These pure functions validate flyToWorkTicketInfo before status transitions.
 */

/**
 * Validates required fields before submitting a ticket with "new" status.
 * @param {Object} ticketInfo - The flyToWorkTicketInfo object
 * @returns {string} Error message if validation fails, empty string if valid
 */
export const validateNewStatusBeforeSubmit = (ticketInfo) => {
  const validationRules = [
    {
      condition: () => !ticketInfo.preferredFlightDate,
      message: 'Preferred Flight Date in tab Business Support is required',
    },
    {
      condition: () => !ticketInfo.noFlightNeeded && !ticketInfo.departureAirports,
      message: 'Departure airports in tab Business Support is required',
    },
    {
      condition: () => !ticketInfo.noFlightNeeded && !ticketInfo.arrivalAirports,
      message: 'Arrival airports in tab Business Support is required',
    },
    {
      condition: () => !ticketInfo.noFlightNeeded && !ticketInfo.staffLuggage,
      message: 'Staff Luggage in tab Operational Support is required',
    },
    {
      condition: () => ticketInfo.isBookReturnFlight && !ticketInfo.brfReturnFlightDate,
      message: 'BRF Return Preferred Flight Date in tab Business Support is required',
    },
    {
      condition: () => ticketInfo.isBookReturnFlight && !ticketInfo.brfDepartureAirport,
      message: 'BRF Return Departure airport in tab Business Support is required',
    },
    {
      condition: () => ticketInfo.isBookReturnFlight && !ticketInfo.brfArrivalAirport,
      message: 'BRF Arrival airport in tab Business Support is required',
    },
    {
      condition: () => ticketInfo.isRailAndFly && !ticketInfo.homeTrainStationName,
      message: 'Train station name in tab Business Support is required',
    },
  ];

  const failedRule = validationRules.find((rule) => rule.condition());
  return failedRule ? failedRule.message : '';
};

/**
 * Validates required fields before submitting a ticket with "confirmed" status.
 * @param {Object} ticketInfo - The flyToWorkTicketInfo object
 * @returns {string} Error message if validation fails, empty string if valid
 */
export const validateConfirmedStatusBeforeSubmit = (ticketInfo) => {
  let result = '';

  if (!ticketInfo.noFlightNeeded) {
    if (!ticketInfo.flights || !ticketInfo.flights.some((flight) => flight.flightNumber)) {
      result = 'Flight in tab Business Tavel Team is required';
    }
  }

  return result;
};
